// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2fwhP","dragIcon":"Choice_dragIcon__lXb-C","left":"Choice_left__3WPhl","input":"Choice_input__20hdg"};